import React from 'react'
import {
  Button,
  Col,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap'

import Swal from 'sweetalert2'

import { CameraCapture, } from '../../components/camera'

class TransferModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      payment_pay_image: '',
      payment_pay_number: '',
      payment_pay: [],
    }
  }

  componentDidUpdate(props_old) {
    if (!props_old.show && this.props.show) {
      this._fetchData()
    }
  }

  _fetchData = () => this.setState({
    payment_pay_number: this.props.payment_pay.payment_pay_number,
    payment_pay_image: this.props.payment_pay.payment_pay_image,
    payment_pay: this.props.payment_pay
  })

  _handleSave = () => {
    const { payment_pay, payment_pay_number, } = this.state
    payment_pay.idx = this.props.idx
    payment_pay.payment_pay_number = payment_pay_number

    if (payment_pay.payment_pay_require_number && payment_pay_number === '') {
      Swal.fire({ text: "กรุณาระบุเลขที่รายการ", icon: "warning", })
    } else if (payment_pay.payment_pay_require_image && payment_pay.payment_pay_image === '') {
      Swal.fire({ text: "กรุณาถ่ายหลักฐาน", icon: "warning", })
    } else {
      Swal.fire({ text: "บันทึกข้อมูลสำเร็จ", icon: "success", })
      this.props.onSave({ payment_pay })
    }
  }

  _handleCaptureTransfer = (value) => {
    const { payment_pay, } = this.state
    payment_pay.payment_pay_image = value

    this.setState({ payment_pay, })
  }

  _handleClose = () => this.props.onClose()

  render() {
    return (
      <Modal size="lg" centered isOpen={this.props.show} toggle={this._handleClose}>
        <ModalHeader toggle={this._handleClose}>โอนเงิน</ModalHeader>
        <ModalBody>
          <FormGroup>
            <label>เลขที่รายการ {this.state.payment_pay.payment_pay_require_number && <font color="#F00"><b>*</b></font>}</label>
            <Input
              type="text"
              value={this.state.payment_pay_number}
              onChange={(e) => this.setState({ payment_pay_number: e.target.value })}
              disabled={!this.state.payment_pay.payment_pay_require_number}
              required={this.state.payment_pay.payment_pay_require_number}
            />
            <p className="text-muted m-0">Example : -.</p>
          </FormGroup>
          {this.state.payment_pay.payment_pay_require_image && <CameraCapture key="transfer-capture" onCapture={(e) => this._handleCaptureTransfer(e)} />}
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="success" onClick={this._handleSave}>ยืนยัน</Button>
          <Button type="button" onClick={this._handleClose}>ยกเลิก</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default TransferModal